<div class="disclaimer">
  <h1 class="disclaimer-header">{{ 'module.public.disclaimer.headerText' | translate }}</h1>

  <div [innerHTML]="'module.public.disclaimer.content' | translate"></div>
</div>
